import { createFileRoute } from "@tanstack/react-router";
import { ensureRouteTranslationModuleLoaded } from "@/services/culture/routeTranslationPreload";

export const Route = createFileRoute("/admin")({
  beforeLoad: async () => {
    await ensureRouteTranslationModuleLoaded("admin");
  },
  staticData: {
    title: "home.title",
  },
});
